import * as React from 'react';
import { Check } from 'lucide-react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        // Base styles
        'peer border-main size-5 shrink-0 rounded-[2px] border bg-white shadow-sm transition-shadow outline-none',

        // Checked state
        'data-[state=checked]:bg-hydrangea-500 data-[state=checked]:border-hydrangea-500 data-[state=checked]:text-white',

        // Focus state
        'focus-visible:border-ring focus-visible:ring-ring/75 focus-visible:ring-[2px] focus-visible:ring-offset-2',

        // Invalid/error state
        'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',

        // Disabled state
        'disabled:cursor-not-allowed disabled:opacity-50',

        // Custom className override
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <Check className="size-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
